import { media, style } from "typestyle";
import { colours } from "./colours";
import { TABLETDEVICEWIDTH } from "config/constants";

export const appStyle = style(
  {
    color: colours.primaryText,
  },
  media(
    { maxWidth: TABLETDEVICEWIDTH },
    {
      $nest: {
        "body &": {
          flexDirection: "column",
          fontSize: 13,
        },
      },
    }
  )
);

export const headerStyle = style({
  width: '100%',
  padding: "10px",
  marginBottom: "10px",
  backgroundColor: colours.panelBackground,
  borderRadius: "6px",
})

export const formStyle = style({
  background: "white",
  border: `1px solid ${colours.lightBorder}`,
  borderRadius: "6px",
});